import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FournisseurAuth } from './auth/AuthContext';
import { FournisseurToasts } from './components/ui/Toast';
import { FournisseurMarque } from './marque/FournisseurMarque';
import { amorcerMarque } from './marque/marque';
import { ErreurApi } from './lib/api';
import { amorcerSonnerieMessage } from './messagerie/sonnerieMessage';
import { Router } from './router';
import './index.css';

// Monté ici (racine de l'app, actif même sur /login) et non dans
// `FournisseurAppel` : ce dernier n'existe qu'après connexion, alors que le
// premier geste réel de l'utilisateur — cliquer sur « Se connecter » — a
// lieu avant. Sans ça, le son de notification reste bloqué tant qu'aucun
// clic n'a lieu après l'arrivée sur le tableau de bord.
amorcerSonnerieMessage();
// Marque blanche (TF-436) : la dernière connue de ce navigateur, avant le premier rendu.
amorcerMarque();

const clientRequetes = new QueryClient({
  defaultOptions: {
    queries: {
      // Une session expirée (401) ne se rattrape pas en réessayant : elle
      // déclenche déjà la redirection vers /connexion (voir AuthContext). Un
      // service indisponible (redéploiement) revient en quelques secondes :
      // on insiste davantage (1 s, 2 s, 4 s).
      retry: (nombre, erreur) => {
        if (erreur instanceof ErreurApi && erreur.estNonAuthentifie) return false;
        return nombre < (erreur instanceof ErreurApi && erreur.estIndisponible ? 3 : 1);
      },
      refetchOnWindowFocus: false,
    },
  },
});

const racine = document.getElementById('root');
if (!racine) throw new Error("L'élément #root est absent de index.html");

createRoot(racine).render(
  <StrictMode>
    <QueryClientProvider client={clientRequetes}>
      <BrowserRouter>
        <FournisseurMarque>
          <FournisseurAuth>
            <FournisseurToasts>
              <Router />
            </FournisseurToasts>
          </FournisseurAuth>
        </FournisseurMarque>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
